type Config = {
    mailchimpEnabled: boolean;
    constantContactEnabled: boolean;
    quickbooksEnabled: boolean;
};

export function shouldShowMailchimp(config: Config) {
    if (
        typeof Peep !== 'undefined' &&
        Peep.currentPeep &&
        !Peep.currentPeep.getEmailModels().length
    )
        return false;

    return config.mailchimpEnabled;
}

export function shouldShowConstantContact(config: Config) {
    if (
        typeof Peep !== 'undefined' &&
        Peep.currentPeep &&
        !Peep.currentPeep.getEmailModels().length
    )
        return false;

    return config.constantContactEnabled;
}
